module.exports = __webpack_public_path__ + "assets/img/coin.f6c578f9.png";